module.exports = "<button [cmShareButton]=\"button.provider\"\r\n        [image]=\"image\"\r\n        [url]=\"url\"\r\n        (popUpClose)=\"onPopUpClose($event)\"\r\n>\r\n  <span class=\"share-button-inner\" [innerHtml]=\"button.template\"></span>\r\n</button>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/social-share/share-button/share-button.component.html
// module id = ../../../../../src/app/social-share/share-button/share-button.component.html
// module chunks = 4